import React from "react";
import { ScopeTag } from "../shared/common/EstimateEngine/EstimateEngineTypes";

export type MitToReconScopeFilterOption = "all" | "water" | "mold" | "water_only" | "mold_only";

const FILTER_OPTIONS: { value: MitToReconScopeFilterOption; label: string }[] = [
  { value: "all", label: "All" },
  { value: "water", label: "Water" },
  { value: "mold", label: "Mold" },
  { value: "water_only", label: "Just Water" },
  { value: "mold_only", label: "Just Mold" },
];

export const matchesScopeFilter = (scopes: string[] | undefined, filter: MitToReconScopeFilterOption): boolean => {
  const hasWater = !!scopes?.includes(ScopeTag.water_mitigation);
  const hasMold = !!scopes?.includes(ScopeTag.mold);
  switch (filter) {
    case "all":
      return true;
    case "water":
      return hasWater;
    case "mold":
      return hasMold;
    case "water_only":
      return hasWater && !hasMold;
    case "mold_only":
      return hasMold && !hasWater;
  }
};

interface MitToReconScopeFilterProps {
  selectedFilter: MitToReconScopeFilterOption;
  onChange: (filter: MitToReconScopeFilterOption) => void;
}

export const MitToReconScopeFilter: React.FC<MitToReconScopeFilterProps> = ({ selectedFilter, onChange }) => (
  <div className="flex items-center gap-2 mb-4">
    <span className="text-sm font-medium text-gray-700">Scope:</span>
    {FILTER_OPTIONS.map(({ value, label }) => {
      const isSelected = value === selectedFilter;
      return (
        <button
          key={value}
          onClick={() => onChange(value)}
          className={`text-sm px-3 py-1 rounded-full border transition-colors ${
            isSelected ? "bg-blue-600 border-blue-600 text-white" : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
          }`}
        >
          {label}
        </button>
      );
    })}
  </div>
);
